export default __webpack_public_path__ + "static/og-rejecting-automl-5d56b15cd2e2ecdbf14f8a05cbfe311f.jpg";